//@ts-ignore
import React, { memo, useContext, useEffect } from 'react';
import { ComponentMap, ContextProvider } from '../../utils';
import { NavigationContext, NavigationContextProvider } from '../../contexts';
import { ToastType } from './types';
import { useAuthenticatedFormsLeadMutation } from '../../hooks';
const AuthenticatedLeadFormsContainer = () => {
  const {
    screen,
    metadata,
    type,
    request,
    leadApiParams,
    accessToken,
    logApiEvent,
    logUserEvent,
    onComplete,
    setApplicationId,
    setIsApiLoading
  } = useContext(NavigationContext);
  const initLead = useAuthenticatedFormsLeadMutation({
    leadApiParams,
    accessToken: accessToken,
    loanNumber: '',
    logApiEvent,
    logUserEvent,
    type,
    onComplete,
    setApplicationId,
    setIsApiLoading
  });
  useEffect(() => {
    if (type === 'AuthCashOut' || type === 'AuthRefi' || type === 'AuthPurchase') {
      initLead.mutate({
        requestBody: request,
        isLastScreen: false
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [request]);
  const Component = ComponentMap[screen];
  return /*#__PURE__*/React.createElement(Component, metadata);
};
const AuthenticatedLeadForms = _ref => {
  let {
    config,
    ...props
  } = _ref;
  const {
    accessToken,
    metadata,
    logApiEvent,
    onComplete,
    leadApiParams,
    logUserEvent
  } = props;
  return /*#__PURE__*/React.createElement(ContextProvider, null, /*#__PURE__*/React.createElement(NavigationContextProvider, {
    config: config,
    initialState: metadata.initialState,
    accessToken: accessToken,
    logUserEvent: logUserEvent,
    logApiEvent: logApiEvent,
    leadApiParams: leadApiParams,
    onComplete: onComplete,
    request: metadata.request
  }, /*#__PURE__*/React.createElement(AuthenticatedLeadFormsContainer, null)));
};
export { ToastType };
export default /*#__PURE__*/memo(AuthenticatedLeadForms);
//# sourceMappingURL=index.js.map